import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeAgentIdCommand extends BaseCommand {
  CommandName = "ChangeAgentId";
  Command: { BookingItemTmpId: string; AgentId: string | null };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, agentId: string | null) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, AgentId: agentId };
  }
}
